import styles from "./StatTile.module.css";

/**
 * Single KPI tile ("Total Users", "MRR", "Error Rate") -- the building block
 * every analytics dashboard in this app is made of. `delta` is an optional
 * signed change indicator (e.g. "+4.2%") colored green/red by `deltaTone`.
 */
export function StatTile({ label, value, delta, deltaTone = "success", sublabel }) {
  return (
    <div className={styles.tile}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
      {(delta || sublabel) && (
        <div className={styles.meta}>
          {delta && <span className={[styles.delta, styles[deltaTone]].join(" ")}>{delta}</span>}
          {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
        </div>
      )}
    </div>
  );
}
